<h2 class="container-heading__heading">{{heading}}</h2>
<p class="container-heading__subtitle" *ngIf="subtitle">{{ subtitle }}</p>
<p class="container-heading__subtitle" *ngIf="subtitle2" [innerHTML]="subtitle2"></p>
